import { BreakContent } from "../utils/BreakContent";
import { copyTextToClipboard } from "../utils/copyTextToClipboard";
import { createURL } from "../utils/createURL";
import { Div2Floor } from "../utils/Div2Floor";
import { SVG_FillRect } from "../utils/SVG_FillRect.js";
import { XML_FillRect } from "../utils/XML_FillRect.js";
import { SVG_DrawDashLine } from "../utils/SVG_DrawDashLine.js";
import { XML_DrawLine } from "../utils/XML_DrawLine.js";
import { SVG_DrawTri2 } from "../utils/SVG_DrawTri2.js";
import { XML_DrawTri2 } from "../utils/XML_DrawTri2.js";
import { XML_DrawHyperLink } from "../utils/XML_DrawHyperLink.js";
import { CreatePath2D } from "../utils/CreatePath2D.js";
import { DetermineBrightness } from "../utils/DetermineBrightness.js";
import { FormatFieldValue } from "../utils/FormatFieldValue.js";
import { isNumeric } from "../utils/isNumeric.js";
import { copyTextToClipboardNoEvent } from "../utils/copyTextToClipboardNoEvent.js";
import {
  enumAutoSizeBehavior,
  enumBoxShapes,
  enumFillMode,
  enumTextEditFlashCursor,
  enumXMLType,
  gBrightnessThreshold,
  kBackspaceKey,
  kBulletChar,
  kDeleteKey,
  kDownArrow,
  kEscKey,
  kF10Key,
  kF11Key,
  kF12Key,
  kF1Key,
  kF2Key,
  kF3Key,
  kF4Key,
  kF5Key,
  kF6Key,
  kF7Key,
  kF8Key,
  kF9Key,
  kGreen,
  kLeftArrow,
  kRed,
  kReturnKey,
  kRightArrow,
  kTabKey,
  kUpArrow,
  kZeroWidthSpace
} from "../constants";
import { MeasureTextHeightAdv } from "../utils/MeasureTextHeightAdv";
import { QElement } from "./QElement";
import { QKeyBoardInfo } from "../utils/QKeyBoardInfo";
import { QPoint } from "./QPoint";
import { QRect } from "./QRect";
import { shadeColor } from "../utils/shadeColor";
import { SVG_DrawLine } from "../utils/SVG_DrawLine";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { TruncateText } from "../utils/TruncateText";
import { XML_DrawDashLine } from "../utils/XML_DrawDashLine";
import { XML_DrawText } from "../utils/XML_DrawText";
import { Globals } from "./Globals";
import { SetCtxFont } from "../utils/SetCtxFont";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { CenterIt } from "../utils/CenterIt";
import { SVG_DrawText } from "../utils/SVG_DrawText";

export class QTextEditBase extends QElement {
  constructor() {
    super();
    this.fContent = "";
    this.fDisplayContent = false;
    this.fInsertionStart = -1;
    this.fInsertionEnd = -1;
    this.fFlashCursorState = enumTextEditFlashCursor.drawCursor;
    this.fControlInsertionStart = -1;
    this.fCellEditStartWidth = null;
    this.fEnableAutoResize = false;

    this.fMaskContent = false;
    this.fBlankMsg = null;

    //this.fSecondaryContent = null;

    this.fMaxLen = 32000;

    this.fStartWidth = null;
    this.fStartHorzPos = null;
    this.fAutoSizeBehavior = enumAutoSizeBehavior.cellEdit;

    this.fNumRows = 1;
    this.fLeftIndent = 0;
    this.fRightIndent = 0;
    this.fCellHPadding = 2;

    this.fPriorContent = null;
    this.fPriorContentRows = null;

    this.fReturnNewline = false;
    this.fCellDrawBuffer = null;
    this.fActiveSelection = false; // render the border highlight when text edit is the keyboard target

    // this.fFirstAltDrawLine = false; Approach #1 - output font and cliprect only on first line
    // this.fTextBlockList = null; // Approach #2 - cache everything and output at end
    //this.fKeyPadPanel = null;

    //this.fCacheSlot = null;
    // Temp
    //this.fTextRendered = false;
    this.fInvalidEntry = null;
    this.fBreakChars = null;
    this.fIconBuffer = 3;
    this.fWhiteEditFill = true;
    this.fLastCursorTime = -1;
    this.fCursorVisible = false;
  }

  InitTextEditBase() {
    this.CreateMeasureBuffer();
  }

  CloseElement() {
    this.DoCloseElement();
  }

  GetCursor() {
    return "text";
  }

  SetNoNoCharacters(nono) {
    this.fNoNoCharacters = nono;
  }

  GetNoNoCharacters() {
    return this.fNoNoCharacters;
  }

  TEStartEdit() {
    if (this.AutoResizeEnabled()) {
      this.fStartWidth = this.GetWidth();
      this.fStartHorzPos = this.GetPositionX();
      this.AutoResize();
    }
    Globals._keyPadPanel = true;
  }

  TEFinishEdit() {
    if (this.AutoResizeEnabled()) {
      var curWidth = this.GetWidth();
      if (curWidth != this.fStartWidth) this.SetWidth(this.fStartWidth);

      var curPosX = this.GetPositionX();
      if (curPosX != this.fStartHorzPos) this.SetPositionX(this.fStartHorzPos);
    }
    Globals._keyPadPanel = false;
  }

  SetMaxLen(maxLen) {
    this.fMaxLen = maxLen;
  }

  GetMaxLen() {
    return this.fMaxLen;
  }

  SetNumRows(numRows) {
    this.fNumRows = numRows;
  }

  GetNumRows(limited) {
    return this.fNumRows;
  }

  TEFilterInput(inputString) {
    var nonos = this.GetNoNoCharacters();
    if (nonos != null) {
      for (var badIdx in nonos) {
        var badVal = nonos[badIdx];
        if (inputString.includes(badVal)) return true;
      }
    }
    return false;
  }

  InsertString(theString, keyInfo) {
    var okToAdd = true;

    if (this.TEFilterInput(theString)) return okToAdd;

    var theContent = this.GetRealContent();
    var contentRows = this.TEBreakContent(theContent, null);
    var sLen = theContent.length;

    var a = theContent.slice(0, this.fInsertionStart);
    var b = theContent.slice(this.fInsertionEnd, sLen);
    var updatedContent = a.concat(theString, b);

    var newLen = updatedContent.length;
    var charLimitReached = newLen > this.GetMaxLen();
    var rowLimitReached = contentRows.length > this.GetNumRows() && theString.indexOf("\n") > -1;

    if (charLimitReached || rowLimitReached) {
      okToAdd = false;
    }

    if (okToAdd) {
      this.SetEditContent(updatedContent);
      this.fInsertionStart = this.fInsertionStart + theString.length;
      this.fInsertionEnd = this.fInsertionStart;
      this.fControlInsertionStart = this.fInsertionEnd;
      this.AutoResize();
      this.DoAfterKeyPress(keyInfo);
    }

    return okToAdd;
  }

  TEHandleKeyEntry(keyInfo) {
    var keyChar = String.fromCharCode(keyInfo.charCode);

    return this.InsertString(keyChar, keyInfo);
  }

  TEHandleCtrlShortCut(keyInfo) {
    var charCode = keyInfo.charCode;
    var keyChar = String.fromCharCode(charCode);
    var handled = true;

    switch (keyChar) {
      case "a":
        this.SelectAll();
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  IsTextSelection() {
    var noSelection = this.fInsertionStart == this.fInsertionEnd;
    return !noSelection;
  }

  GetTextSelection() {
    var theContent = this.GetRealContent();
    var err = true;
    theContent = theContent.trim();
    var selectionStart = this.fInsertionStart;
    var selectionEnd = this.fInsertionEnd;
    var selectedText = theContent.substring(selectionStart, selectionEnd);
    var myRegEx = /\[(.*)\]/;
    var targetFieldDef = selectedText.match(myRegEx);
    if (targetFieldDef != null) {
      targetFieldDef = targetFieldDef[0].replace(/[\[\]']+/g, "");
      selectedText = targetFieldDef;
    } else {
      selectedText = selectedText.replace(/[\[\]']+/g, "");
    }
    return selectedText;
  }

  SimulateKey(theKey) {
    var keyInfo = new QKeyBoardInfo();
    keyInfo.keyCode = theKey; //kBackspaceKey;
    keyInfo.shiftKey = false;
    keyInfo.ctrlKey = false;
    keyInfo.altKey = false;
    this.TEHandleKeyboard(keyInfo);
  }

  TEHandleKeyboard(keyInfo) {
    var theContent = this.GetRealContent();
    var sLen = theContent.length;
    var handled = false;
    var noSelection = !this.IsTextSelection();
    var keyCode = keyInfo.keyCode;
    var shiftOn = keyInfo.shiftKey;
    var ctrlKey = keyInfo.ctrlKey;
    var altKey = keyInfo.altKey;

    var mayNeedResize = false;
    var handleEsc = this.GetEnableEsc();

    switch (keyCode) {
      case kEscKey:
        if (handleEsc) {
          var updatedContent = "";
          this.SetEditContent(updatedContent);
          this.SetInsertAtStart();
          handled = true;
        }
        break;
      case kBackspaceKey: // Backspace
      case kDeleteKey: // Delete
        if (noSelection) {
          if (keyCode == kBackspaceKey) {
            if (this.fInsertionStart > 0) this.fInsertionStart--;
          } else {
            if (this.fInsertionStart < sLen) this.fInsertionEnd++;
          }
        }
        var c1 = theContent.slice(0, this.fInsertionStart);
        var c2 = theContent.slice(this.fInsertionEnd, sLen);
        var updatedContent = c1 + c2;
        this.SetEditContent(updatedContent);
        this.fInsertionEnd = this.fInsertionStart;
        this.fControlInsertionStart = this.fInsertionEnd;
        this.DoAfterKeyPress(keyInfo);
        handled = true;
        mayNeedResize = true;
        break;
      case kLeftArrow: // Left arrow
        if (shiftOn) {
          //console.log("kLeftArrow - shifton - enter: is:", this.fInsertionStart, " ie:",this.fInsertionEnd, " cis:", this.fControlInsertionStart);
          if (this.fInsertionEnd > this.fControlInsertionStart) this.fInsertionEnd--;
          else if (this.fInsertionStart > 0) this.fInsertionStart--;
          //console.log("kLeftArrow - shifton - exit: is:", this.fInsertionStart, " ie:",this.fInsertionEnd, " cis:", this.fControlInsertionStart);
        } else if (noSelection) {
          if (this.fInsertionStart > 0) {
            this.fInsertionStart--;
            this.fInsertionEnd = this.fInsertionStart;
            this.fControlInsertionStart = this.fInsertionStart;
          }
        } else {
          this.fInsertionEnd = this.fInsertionStart;
          this.fControlInsertionStart = this.fInsertionStart;
        }
        handled = true;
        break;
      case kRightArrow: // Right arrow
        if (shiftOn) {
          //console.log("kRightArrow - shifton - enter: is:", this.fInsertionStart, " ie:",this.fInsertionEnd, " cis:", this.fControlInsertionStart);
          if (this.fInsertionStart < this.fControlInsertionStart) this.fInsertionStart++;
          else if (this.fInsertionEnd < sLen) this.fInsertionEnd++;
          //console.log("kRightArrow - shifton - exit: is:", this.fInsertionStart, " ie:",this.fInsertionEnd, " cis:", this.fControlInsertionStart);
        } else if (noSelection) {
          if (this.fInsertionStart < sLen) {
            this.fInsertionEnd++;
            this.fInsertionStart = this.fInsertionEnd;
            this.fControlInsertionStart = this.fInsertionStart;
          }
        } else {
          this.fInsertionStart = this.fInsertionEnd;
          this.fControlInsertionStart = this.fInsertionStart;
        }
        handled = true;
        break;
      case kTabKey:
      case kUpArrow:
      case kDownArrow:
      case kF1Key:
      case kF2Key:
      case kF3Key:
      case kF4Key:
      case kF5Key:
      case kF6Key:
      case kF7Key:
      case kF8Key:
      case kF9Key:
      case kF10Key:
      case kF11Key:
      case kF12Key:
        break;
      case kReturnKey:
        if (ctrlKey || this.GetReturnNewline() || shiftOn) {
          this.InsertString("\n");
          handled = true;
        } else {
          // Maybe a better way to handle this?
          handled = this.HandleReturnKey();
        }
        break;
      default:
        var teHandleKeyEntry = true;
        if (ctrlKey) {
          handled = this.TEHandleCtrlShortCut(keyInfo);
          teHandleKeyEntry = !handled && altKey;
        }
        if (!handled && teHandleKeyEntry) {
          handled = this.TEHandleKeyEntry(keyInfo);
        }
        if (!handled) {
          this.DoAfterKeyPress(keyInfo);
        }
        break;
    }

    if (mayNeedResize) this.AutoResize();

    return handled;
  }

  DoAfterKeyPress(theKey) {
    //Override this if you want to use it.
  }

  // Override from QElement
  DoTimerFire(timerDone) {
    if (timerDone) {
      this.fFlashCursorState = enumTextEditFlashCursor.hideCursor;
    } else {
      if (this.fFlashCursorState == enumTextEditFlashCursor.drawCursor)
        this.fFlashCursorState = enumTextEditFlashCursor.hideCursor;
      else this.fFlashCursorState = enumTextEditFlashCursor.drawCursor;
    }
  }

  SelectFieldDefText(value) {
    var fieldDef = value;
    var theContent = this.GetEditContent();
    if (theContent.length > fieldDef.length + 2) {
      this.fInsertionStart = theContent.length - fieldDef.length - 2;
      this.fInsertionEnd = theContent.length;
      this.fControlInsertionStart = theContent.length - fieldDef.length - 2;
    } else {
      this.fInsertionStart = 0;
      this.fInsertionEnd = fieldDef.length + 2;
      this.fControlInsertionStart = 0;
    }
  }

  SelectAll() {
    var theContent = this.GetEditContent();
    this.fInsertionStart = 0;
    this.fInsertionEnd = theContent.length;
    this.fControlInsertionStart = 0;
  }

  SetInsertAtStart() {
    this.fInsertionStart = 0;
    this.fInsertionEnd = 0;
    this.fControlInsertionStart = 0;
  }

  SetInsertAtEnd() {
    var theContent = this.GetEditContent();
    var l = theContent.length; // - 1;
    if (l < 0) l = 0;
    this.fInsertionStart = l;
    this.fInsertionEnd = this.fInsertionStart;
    this.fControlInsertionStart = this.fInsertionEnd;
  }

  TEGetFontString() {
    // Override this
    return null;
  }

  GetFontSize() {
    return 11;
    // Override this
  }

  GetFontName() {
    return "Arial";
    // Override this
  }

  GetFontBold() {
    return false;
    // Override this
  }

  GetFontItalic(fontItalic) {
    return false;
    // Override this
  }

  GetFontUnderlined() {
    return false;
    // Override this
  }

  TEGetVAlignment() {
    // Override this
    return this.fVAlignment ? this.fVAlignment : "top";
  }

  TEGetAlignment(includeJustify) {
    // Override this
    return "left";
  }

  TEMeasureText(theText) {
    if (!this.fMeasureBuffer) this.CreateMeasureBuffer();
    var ctx = this.fMeasureBuffer.getContext("2d");

    //	if (setFont)
    //	{
    var fontInfo = this.TEGetFontString();
    SetCtxFont(ctx, fontInfo);
    //	}

    //ctx.font = fontInfo;
    var txtDim = ctx.measureText(theText);
    var lengthInPixels = Math.ceil(txtDim.width);

    return lengthInPixels;
  }

  SetBorderRadius(radius) {
    this.fBorderRadius = radius;
    this.fLeftIndent = this.fBorderRadius / 2;
  }

  // This is the amount to indent from the left side of the element
  TELeftIndent() {
    return this.fLeftIndent;
  }

  TERightIndent() {
    return this.fRightIndent;
  }

  // This is the amount of space to indent from the cell border
  GetCellHPadding() {
    return this.fCellHPadding;
  }

  TEGetTextHOffset(theContent, leftEdge, alignment, setFont) {
    var cellWidth = this.GetWidth();
    var cellPadding = this.GetCellHPadding();
    var leftBound = cellPadding + this.TELeftIndent();
    var rightIndent = this.TERightIndent();
    //var rightBound = leftBound + cellWidth - (2*cellPadding) - rightIndent;
    var rightBound = cellWidth - 2 * cellPadding - rightIndent;
    //	var align = this.TEGetAlignment(false);

    var textWidth = 0;
    if (leftEdge) textWidth = this.TEMeasureText(theContent);

    var startPos;
    switch (alignment) {
      case "justify":
      case "left":
        startPos = leftBound;
        break;
      case "center":
        if (leftEdge) startPos = Math.floor((leftBound + rightBound) / 2 - textWidth / 2);
        else startPos = Div2Floor(leftBound + rightBound);
        break;
      case "right":
        startPos = rightBound - textWidth;
        break;
    }
    return startPos + this.GetPositionX();
  }

  TEDrawText(
    ctx,
    theContent,
    xBase,
    yBase,
    txtFillStyle,
    rowInsertionStart,
    rowIndex,
    alignment,
    setFont,
    setProps,
    isStatic,
    isLast
  ) {
    if (setProps) {
      ctx.textBaseline = "middle"; //'top';
      ctx.textAlign = alignment; // this.TEGetAlignment(false);
      ctx.fillStyle = txtFillStyle;
      //ctx.fillStyle= '#FF0000'
    }
    var fS = this.TEGetFontString();
    var hInfo = MeasureTextHeightAdv(fS, this.GetFontSize());
    var rowHeight = hInfo.fTxtHeight;
    rowHeight += 2;

    var textMiddle = yBase + Div2Floor(rowHeight) - Div2Floor(hInfo.fHangingOffset);

    if (this.fFontIcon != null && theContent === this.GetBlankMessage()) {
      ctx.save();
      var fAStyle = this.GetFontIconStyle();
      SetCtxFont(ctx, fAStyle);
      ctx.fillText(this.fFontIcon, xBase, textMiddle);
      xBase += this.GetFontIconLabelWidth() + this.fIconBuffer;
      ctx.restore();
    }

    if (setFont) {
      SetCtxFont(ctx, fS);
    }
    var inEditMode = this.InEditMode();
    if (!inEditMode || isStatic) {
      if (theContent) {
        if (isLast) {
          var clipW = this.GetTextEntryWidthZone();
          theContent = TruncateText(theContent, fS, clipW);
        }
        ctx.fillText(theContent, xBase, textMiddle);
      }
      var isUnderlined = this.GetFontUnderlined();
      if (isUnderlined) {
        ctx.save();
        ctx.strokeStyle = ctx.fillStyle;
        var textWidth = this.TEMeasureText(theContent);
        ctx.beginPath();
        ctx.lineWidth = 1;
        var ycoord = Math.floor(yBase + rowHeight / 1.2 + ThicknessAdjuster(1));
        alignment = ctx.textAlign;
        switch (alignment) {
          case "left":
            ctx.moveTo(xBase + textWidth, ycoord);
            ctx.lineTo(xBase, ycoord);
            ctx.stroke();
            break;
          case "right":
            ctx.moveTo(xBase, ycoord);
            ctx.lineTo(xBase - textWidth, ycoord);
            ctx.stroke();
            break;
          default:
            ctx.moveTo(xBase - textWidth / 2, ycoord);
            ctx.lineTo(xBase + textWidth / 2, ycoord);
            ctx.stroke();
        }
        ctx.restore();
      }
    } else {
      var is = this.fInsertionStart - rowInsertionStart;
      if (is < 0) is = 0;

      var ie = this.fInsertionEnd - rowInsertionStart;
      var l = theContent.length;
      if (ie > l) ie = l;

      ctx.textAlign = "left";
      if (is > 0) {
        var preSelection = theContent.substring(0, is);
        ctx.fillText(preSelection, xBase, textMiddle);
        var txtDim = ctx.measureText(preSelection);
        xBase = xBase + Math.ceil(txtDim.width);
      }

      if (ie > is) {
        ctx.save();
        var selection = theContent.substring(is, ie);
        var txtDim = ctx.measureText(selection);

        ctx.fillStyle = "#3399FF";
        rowHeight = this.GetRowHeight();

        var yRowTop = yBase; // + rowIndex * rowHeight; // + 1;
        ctx.fillRect(xBase, yRowTop - 2, Math.ceil(txtDim.width), rowHeight + 3); // -2

        ctx.fillStyle = "#FFFFFF";
        ctx.fillText(selection, xBase, textMiddle);
        ctx.restore();
        xBase = xBase + txtDim.width;
      }

      if (ie < l) {
        var postSelection = theContent.substring(ie);
        ctx.fillText(postSelection, xBase, textMiddle);
      }
    }
  }

  TEGetFontColor() {
    return this.GetFontColor();
  }

  TEGetFillMode() {
    return enumFillMode.solidFill;
  }

  TEGetFillColor() {
    var fillColor = this.GetFillColor();
    return fillColor;
  }

  TEGetFillColor2() {
    var fillColor = this.GetFillColor2();
    return fillColor;
  }

  TERenderText() {
    return true;
  }

  TEGetTextVOffset(numRows) {
    var vAlign = this.TEGetVAlignment();
    var rowHeight = this.GetRowHeight();
    var yPad = Math.floor(rowHeight / 6);
    var boxHeight = this.GetHeight();

    var txtVOffset;
    switch (vAlign) {
      case "bottom":
        txtVOffset = boxHeight - numRows * rowHeight + yPad * 0 + 1;
        break;
      case "middle":
        var c = rowHeight * numRows;
        txtVOffset = yPad + CenterIt(boxHeight, c) - 1;
        break;
      default:
        txtVOffset = yPad;
        break;
    }
    return txtVOffset + this.GetPositionY();
  }

  OverrideBlankContent() {
    var theContent = this.GetEditContent();
    if (theContent.length == 0) {
      var blankMsg = this.GetBlankMessage();
      if (blankMsg != null) return true;
    }

    return false;
  }

  TEGetContentToRender() {
    var theContent = this.GetEditContent();

    if (this.OverrideBlankContent()) theContent = this.GetBlankMessage();

    return theContent;
  }

  TEDrawAdornment(ctx) {
    // Override this if you want to draw an icon to the left of the text
  }

  TEGrayDisabledText() {
    return !this.IsEnabled();
  }

  TEBreakContent(theContent, altCanvas) {
    if (this.fPriorContent == theContent) return this.fPriorContentRows;

    var contentRows = null;
    var numRows = this.GetNumRows(false);

    if (numRows === 1) {
      contentRows = [];
      contentRows.push(theContent.toString());
    } else {
      var availableWidth = this.GetWidth(); // this.GetAvailableWidth();
      var cellPadding = this.GetCellHPadding();
      var ri = this.TERightIndent();
      var rightMargin = ri + cellPadding;
      var li = this.TELeftIndent();
      var leftMargin = li + cellPadding;
      var fontString = this.TEGetFontString();
      var breakChars = this.TEGetBreakChars();
      var maxRows = Math.ceil(this.GetHeight() / this.GetRowHeight());
      contentRows = BreakContent(
        theContent.toString(),
        maxRows + 1,
        availableWidth,
        leftMargin,
        rightMargin,
        fontString,
        breakChars
      ); // Was 10
    }

    this.fPriorContent = theContent;
    this.fPriorContentRows = contentRows;

    return contentRows;
  }

  TEGetContainerBoundry() {
    return null;
  }

  TEAltGetClipRect(indentAdjust) {
    //Indent adjust - we can be asked for the clip rect if we're filling OR drawing text. For text, we have to adjust for indent.
    var leftIndent = this.TELeftIndent();
    var rightIndent = this.TERightIndent();

    var sx = this.GetPositionX();
    if (indentAdjust) sx += leftIndent;
    var sy = this.GetPositionY();
    var w = this.GetWidth();
    if (indentAdjust) w -= leftIndent + rightIndent;
    var h = this.GetHeight();

    var r = new QRect();
    r.InitRect(sx, sy, sx + w, sy + h);

    var clipBoundary = this.TEGetContainerBoundry();
    if (clipBoundary != null) {
      r = r.ClipRect(clipBoundary);
      if (!r.IsValid()) {
        return null;
      }
    }

    return r;
  }

  // TORK
  TEAltFill(altCanvas) {
    var fillMode = this.TEGetFillMode();
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();
    var r = this.TEAltGetClipRect();
    if (r == null) return;

    var sx = r.fLeft;
    var sy = r.fTop;
    var w = r.fRight - r.fLeft;
    var h = r.fBottom - r.fTop;
    var layer = this.GetLayer();

    var fillStyle = this.TEGetFillColor();
    var fillStyle2 = this.TEGetFillColor2();
    if (fillMode == enumFillMode.solidFill) {
      fillStyle2 = null;
    }
    if (fillMode == enumFillMode.solidFill || fillMode == enumFillMode.linearGradientDown) {
      switch (altCanvasType) {
        case "SVG":
          SVG_FillRect(sx, sy, w, h, fillStyle, fillStyle2, altCanvasElement);
          break;
        case "XML":
          // TORK - This is a primative to fill a rectangle
          XML_FillRect(sx, sy, w, h, fillStyle, fillStyle2, altCanvasElement, layer);
          break;
      }
    } else if (fillMode == enumFillMode.dashline) {
      switch (altCanvasType) {
        case "SVG":
          SVG_DrawDashLine(sx, sy, w, h, fillStyle, altCanvasElement);
          break;
        case "XML":
          XML_DrawDashLine(sx, sy, w, h, fillStyle, altCanvasElement, layer);
          break;
      }
    } else if (fillMode == enumFillMode.separator) {
      var lineThickness = 2;
      sy = sy + h / 2;
      switch (altCanvasType) {
        case "SVG":
          SVG_DrawLine(
            sx,
            sy,
            r.fRight,
            sy,
            fillStyle,
            lineThickness,
            false,
            false,
            altCanvasElement
          );
          break;
        case "XML":
          XML_DrawLine(
            sx,
            sy,
            r.fRight,
            sy,
            fillStyle,
            lineThickness,
            false,
            altCanvasElement,
            layer
          );
          break;
      }
    } else if (fillMode == enumFillMode.triangle || fillMode == enumFillMode.lefttriangle) {
      var leftTri = fillMode == enumFillMode.lefttriangle;
      switch (altCanvasType) {
        case "SVG":
          SVG_DrawTri2(
            sx,
            sy,
            w,
            h,
            fillStyle,
            fillStyle2,
            0,
            true,
            enumBoxShapes.rectangle,
            altCanvasElement,
            fillMode
          );
          break;
        case "XML":
          XML_DrawTri2(sx, sy, w, h, fillStyle, fillStyle2, altCanvasElement, layer, leftTri);
          break;
      }
    }
  }

  TEAltDrawText(theType, drawElement, theContent, x, y, txtFillStyle, alignment) {
    if (theContent.length > 0 || theType == "XML") {
      var clipRect = this.TEAltGetClipRect(true);
      if (clipRect == null) return;

      var fontSize = this.GetFontSize();
      var fontFamily = this.GetFontName();
      var fontBold = this.GetFontBold();
      var fontItalic = this.GetFontItalic();
      var theLayer = this.GetLayer();
      var fontUnderline = this.GetFontUnderlined();
      var hyperLinkType = this.GetLinkType();

      switch (theType) {
        case "SVG":
          SVG_DrawText(
            theContent,
            x,
            y,
            txtFillStyle,
            fontFamily,
            fontSize,
            fontBold,
            fontItalic,
            fontUnderline,
            alignment,
            "top",
            clipRect,
            drawElement
          );
          break;
        case "XML":
          XML_DrawText(
            theContent,
            x,
            y,
            txtFillStyle,
            fontFamily,
            fontSize,
            fontBold,
            fontItalic,
            fontUnderline,
            alignment,
            "top",
            clipRect,
            drawElement,
            theLayer
          );
          if (hyperLinkType !== false) {
            const linkTargetURL = createURL(hyperLinkType, this.GetLinkTarget());
            XML_DrawHyperLink(linkTargetURL, x, y, clipRect, drawElement, theLayer);
          }
          break;
      }
    }
  }

  GetAvailableWidth() {
    //var fontString = this.TEGetFontString();
    var sw = this.GetWidth();
    var cellPadding = this.GetCellHPadding();
    var rightMargin = cellPadding + this.TERightIndent();
    var leftMargin = this.TELeftIndent() + cellPadding;
    var availableWidth = sw - (rightMargin + leftMargin);

    return availableWidth;
  }

  AltDrawText(altCanvas, theContent, x, y, txtFillStyle, alignment) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    this.TEAltDrawText(altCanvasType, altCanvasElement, theContent, x, y, txtFillStyle, alignment);
  }

  RenderTheContent(drawBuffer, inEditMode, txtFillStyle, altCanvas) {
    this.RenderTheText(drawBuffer, inEditMode, txtFillStyle, altCanvas);
  }

  TEGetBreakChars() {
    return this.fBreakChars;
  }

  RenderTheText(drawBuffer, inEditMode, txtFillStyle, altCanvas) {
    var theContent = this.TEGetContentToRender();
    // the altCanvas will receive a performance boost by returning out at this point.
    // However, if the altCanvas is not null, then an export is being done and returning out too soon will prevent cell colors
    // from being rendered in the exported file.
    if ((theContent == "" || theContent == null) && altCanvas == null) return;

    var contentRows = this.TEBreakContent(theContent, altCanvas);
    var numRows = contentRows.length;

    var maxRows = this.GetNumRows(!inEditMode);
    if (numRows > maxRows) numRows = maxRows;

    var secondTextArr = [];
    var leftTextArr = [];

    var textalign = this.TEGetAlignment(true);
    var inEditMode = this.InEditMode();

    var doJustify = false;
    if (textalign == "justify") doJustify = altCanvas ? altCanvas.PreJustifyText() : true;
    var shownAlign = textalign;
    if (!inEditMode && doJustify) {
      for (var r = 0; r < numRows; r++) {
        leftTextArr[r] = contentRows[r];
        secondTextArr[r] = "";
        shownAlign = this.TEGetAlignment(false);
        var textWidth = this.TEMeasureText(contentRows[r]);
        if (textWidth <= this.GetAvailableWidth()) {
          var splitText = contentRows[r].split(":", 2);
          if (splitText.length > 1) {
            leftTextArr[r] = splitText[0] + ":";
            //contentRows[r] = splitText[r] + ":";
            secondTextArr[r] = splitText[1];
          } else {
            var startPoint = Math.floor(contentRows[r].length / 2);
            var splitIdx = contentRows[r].indexOf(" ", startPoint);
            if (splitIdx) {
              leftTextArr[r] = contentRows[r].substring(0, splitIdx);
              secondTextArr[r] = contentRows[r].substring(splitIdx);
            }
          }
          leftTextArr[r] = leftTextArr[r].trim();
          secondTextArr[r] = secondTextArr[r].trim();
        }
      }
    }

    var txtVOffsetBase = this.TEGetTextVOffset(numRows);
    var txtVOffset = txtVOffsetBase;
    var rowHeight = this.GetRowHeight();
    var rowInsertionStart = 0;
    var cx = 0;

    if (altCanvas != null) this.TEAltFill(altCanvas);

    var ctx = null;
    if (drawBuffer) {
      ctx = drawBuffer.getContext("2d");
      ctx.textBaseline = "middle"; // '';  //'top';
      ctx.textAlign = shownAlign; // this.TEGetAlignment(false);
      ctx.fillStyle = txtFillStyle;
    }
    contentRows.length = numRows;
    if (altCanvas) {
      var drawElement = altCanvas.GetCanvasElement();
      var altCanvasType = altCanvas.GetCanvasType();
      if (altCanvasType === "XML") {
        var docType = drawElement.GetDocType();
        if (docType === enumXMLType.PPT) {
          var content = doJustify ? leftTextArr : contentRows;
          var textArray = [content, secondTextArr];
          this.AltDrawText(altCanvas, textArray, null, txtVOffset, txtFillStyle, shownAlign);
          return;
        }
      }
    }
    for (var i = 0; i < numRows; i++) {
      var theMainText = contentRows[i];
      if (secondTextArr[i] && secondTextArr[i] !== "") {
        var secondText = secondTextArr[i];
        theMainText = leftTextArr[i];
        shownAlign = "right";
        var cx2 = this.TEGetTextHOffset(secondText, inEditMode, shownAlign, false);
        if (altCanvas != null)
          this.AltDrawText(altCanvas, secondText, cx2, txtVOffset, txtFillStyle, shownAlign);
        else {
          if (drawBuffer) ctx.textAlign = shownAlign;
          this.TEDrawText(ctx, secondText, cx2, txtVOffset, null, -1, -1, null, false, false);
        }
        shownAlign = "left";
      }
      if (ctx) {
        if (drawBuffer) ctx.textAlign = shownAlign;
        ctx.save();
        if (this.fTheClippedRegion) ctx.clip(this.fTheClippedRegion);
      }
      cx = this.TEGetTextHOffset(theMainText, inEditMode, shownAlign, false);
      if (altCanvas != null)
        this.AltDrawText(altCanvas, theMainText, cx, txtVOffset, txtFillStyle, shownAlign);
      else
        this.TEDrawText(
          ctx,
          theMainText,
          cx,
          txtVOffset,
          null,
          rowInsertionStart,
          i,
          null,
          false,
          false,
          false,
          i === numRows - 1
        );
      rowInsertionStart += contentRows[i].length;
      txtVOffset = txtVOffset + rowHeight;
      if (ctx) ctx.restore();
    }
  }

  GetAdornmentBuffer() {
    return 0;
  }

  CreateClipRegion(sx, sy, ex, ey) {
    this.fTheClippedRegion = CreatePath2D(sx, sy, ex, ey);
    this.fClippedRegionCoords = { sx: sx, sy: sy, ex: ex, ey: ey };
  }

  // TRIISSUE
  DrawTri(ctx, sx, sy, ex, ey, fillStyle1, fillStyle2, leftTriangle) {
    var inset = 2;
    var h = ey - sy - inset * 2;
    var ax = ex - inset - h;
    var ay = sy + inset;
    var bx = ex - inset;
    var by = ay;
    var cx = bx;
    var cy = ey - inset;
    if (leftTriangle == enumFillMode.lefttriangle) {
      ax = ex - inset;
      ay = sy + inset;
      bx = ex - inset - h;
      by = ay;
      cx = bx;
      cy = ey - inset;
    }

    ctx.fillStyle = fillStyle1;
    ctx.beginPath();
    ctx.moveTo(ax, ay);
    ctx.lineTo(bx, by);
    ctx.lineTo(cx, cy);
    ctx.lineTo(ax, ay);
    ctx.closePath();
    ctx.fill();

    if (fillStyle2 != null) {
      var h2 = Div2Floor(h) - 1;
      ay = ay + h2;
      if (leftTriangle == enumFillMode.lefttriangle) ax = ax - h2;
      else ax = ax + h2;
      by = ay;

      ctx.fillStyle = fillStyle2;
      ctx.beginPath();
      ctx.moveTo(ax, ay);
      ctx.lineTo(bx, by);
      ctx.lineTo(cx, cy);
      ctx.lineTo(ax, ay);
      ctx.closePath();
      ctx.fill();
    }
  }

  GetFillRegion() {
    var clippedRegion = this.fTheClippedRegion;
    if (this.fClippedRegion) clippedRegion = this.fClippedRegion;
    return clippedRegion;
  }

  GetTextEntryWidthZone() {
    var clipW = this.GetAvailableWidth();
    if (this.fClippedRegionCoords)
      clipW = Math.abs(
        this.fClippedRegionCoords.ex -
          this.TERightIndent() -
          (this.fClippedRegionCoords.sx + this.TELeftIndent())
      );
    return clipW;
  }

  ClipRenderElement(drawBuffer) {
    var width = this.GetWidth();
    var height = this.GetHeight();
    if (width === 0 || height === 0) return;

    var sx = this.GetPositionX();
    var sy = this.GetPositionY();
    var ex = width + sx;
    var ey = height + sy;

    var ctx = drawBuffer.getContext("2d");

    var fillMode = this.TEGetFillMode();
    var fillStyle = this.TEGetFillColor();
    var fillStyle2 = this.TEGetFillColor2();
    var txtFillStyle = this.TEGetFontColor();
    var inEditMode = this.InEditMode();

    var renderActiveBorder = false;

    if (inEditMode) {
      if (fillMode !== enumFillMode.solidFill && this.fWhiteEditFill) fillStyle = "#FFFFFF";

      if (fillStyle === txtFillStyle)
        txtFillStyle =
          DetermineBrightness(fillStyle) < gBrightnessThreshold ? "#EEEEEE" : "#777777";

      fillMode = enumFillMode.solidFill;
    }

    if (this.TEGrayDisabledText()) {
      ctx.globalAlpha = 0.6;
      fillStyle = shadeColor(fillStyle, -10);
      txtFillStyle =
        DetermineBrightness(fillStyle) < gBrightnessThreshold
          ? shadeColor("#8D8D8D", 5)
          : shadeColor("#8D8D8D", -100);
    } else if (this.OverrideBlankContent()) {
      txtFillStyle =
        DetermineBrightness(fillStyle) < gBrightnessThreshold
          ? "#A9A9A9"
          : shadeColor("#777777", -5);
    }

    switch (fillMode) {
      case enumFillMode.noFill:
        this.CreateClipRegion(sx, sy, ex, ey);
        break;
      case enumFillMode.solidFill:
        this.CreateClipRegion(sx, sy, ex, ey);
        var fillZone = this.GetFillRegion();
        ctx.fillStyle = fillStyle;
        ctx.fill(fillZone);
        renderActiveBorder = true;
        break;
      case enumFillMode.linearGradientDown:
        var grd = ctx.createLinearGradient(sx, sy, sx, ey);
        if (fillStyle == null) fillStyle = "#FFFFFF";
        if (fillStyle2 == null) fillStyle2 = "#FFFFFF";
        grd.addColorStop(0, fillStyle);
        grd.addColorStop(1, fillStyle2);
        ctx.fillStyle = grd;
        this.CreateClipRegion(sx, sy, ex, ey);
        var fillZone = this.GetFillRegion();
        ctx.fill(fillZone);
        break;
      case enumFillMode.triangle:
        this.CreateClipRegion(sx, sy, ex, ey);
        this.DrawTri(ctx, sx, sy, ex, ey, fillStyle, fillStyle2, enumFillMode.triangle);
        break;
      case enumFillMode.lefttriangle:
        //ctx.fillStyle = "#FFFFFF";
        this.CreateClipRegion(sx, sy, ex, ey);
        //ctx.fill(this.fTheClippedRegion);
        this.DrawTri(ctx, sx, sy, ex, ey, fillStyle, fillStyle2, enumFillMode.lefttriangle);
        break;
      case enumFillMode.separator:
        //ctx.fillStyle = "#FFFFFF";
        this.CreateClipRegion(sx, sy, ex, ey);
        //ctx.fill(this.fTheClippedRegion);
        var my = sy + Div2Floor(ey - sy);
        ctx.strokeStyle = fillStyle;
        ctx.setLineDash([]);
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(sx + 1, my);
        ctx.lineTo(ex - 1, my);
        ctx.stroke();
        return; // Do not want to draw the text in this case
      case enumFillMode.dashline:
        //ctx.fillStyle = "#FFFFFF";
        this.CreateClipRegion(sx, sy, ex, ey);
        //ctx.fill(this.fTheClippedRegion);
        var my = sy + Div2Floor(ey - sy);
        ctx.strokeStyle = fillStyle;
        ctx.setLineDash([5, 2]);
        ctx.lineWidth = 2;
        ctx.lineJoin = "bevel";
        ctx.beginPath();
        ctx.moveTo(sx + 1, my);
        ctx.lineTo(ex - 1, my);
        ctx.stroke();
        break;
    }

    if (renderActiveBorder && inEditMode && this.fActiveSelection) {
      this.RenderActiveBorder(ctx, sx, sy, ex, ey);
    }

    if (this.TERenderText()) {
      var fS = this.TEGetFontString();
      SetCtxFont(ctx, fS);

      this.TEDrawAdornment(ctx);
      var dragger = this.fDragger;
      if (!dragger) this.RenderTheContent(drawBuffer, inEditMode, txtFillStyle, null);
    }
    ctx.globalAlpha = 1;
  }

  RenderActiveBorder(ctx, sx, sy, ex, ey) {
    var borderOffset = 1.5;
    var borderColor = Globals._themeMode.text.hover;
    var lineWidth = 1;

    if (this.fInvalidEntry != null) {
      if (this.fInvalidEntry === true) borderColor = kRed;
      if (this.fInvalidEntry === false) borderColor = kGreen;
    }

    ctx.save();
    ctx.lineWidth = lineWidth;
    ctx.shadowBlur = 2;
    ctx.shadowColor = borderColor;
    ctx.strokeStyle = borderColor;

    if (this.fClippedRegion) {
      ctx.stroke(this.fClippedRegion);
    } else {
      var borderPath = CreatePath2D(
        sx - borderOffset,
        sy - borderOffset,
        ex + borderOffset,
        ey + borderOffset
      );
      ctx.shadowOffsetX = -0.5;
      ctx.shadowOffsetY = -0.5;

      ctx.stroke(borderPath);
    }
    ctx.restore();
  }

  ConvertInsertionToLocation() {
    var theContent = this.IsContentMasked() ? this.GetEditContent() : this.GetRealContent();
    var contentRows = this.TEBreakContent(theContent, null);

    if (contentRows == null) console.log("contentRows == null");

    var row = 0;
    var done = false;
    var targetCharIndex = this.fInsertionStart;
    var colIndex = targetCharIndex;

    var l = 0;
    while (!done && contentRows[row]) {
      var c = contentRows[row].length;
      l = l + c;
      if (contentRows[row][colIndex - 1] === kZeroWidthSpace) {
        row++;
        colIndex = colIndex - c;
        done = true;
      }
      if (targetCharIndex <= l) done = true;
      else {
        row++;
        colIndex = colIndex - c;
      }
    }
    if (row >= contentRows.length) row = contentRows.length - 1;

    var yLoc = this.TEGetTextVOffset(contentRows.length) + this.GetRowHeight() * row;
    // this.GetRowHeight() * row + 1;
    var preSelect = contentRows[row].substring(0, colIndex);

    var textalign = this.TEGetAlignment(false);
    var xLoc =
      this.TEGetTextHOffset(contentRows[row], true, textalign, true) +
      this.TEMeasureText(preSelect);

    var p = new QPoint();
    p.InitPoint(xLoc, yLoc);

    return p;
  }

  ConvertLocationToInsertion(x, y) {
    var theContent = this.IsContentMasked() ? this.GetEditContent() : this.GetRealContent();
    if (theContent.length == 0) return 0;

    //var cellPadding = this.GetCellPadding();
    var yTop = this.GetPositionY() + 1;
    var rowHeight = this.GetRowHeight();
    var theRow = Math.floor((y - yTop) / rowHeight);

    var contentRows = this.TEBreakContent(theContent, null);
    var numRows = contentRows.length;

    if (theRow < 0) theRow = 0;

    if (theRow >= numRows) theRow = numRows - 1;

    var rowContent = contentRows[theRow];
    var rowBase = 0;
    for (var i = 0; i < theRow; i++) rowBase += contentRows[i].length;

    var ctx = this.fMeasureBuffer.getContext("2d");
    var fontInfo = this.TEGetFontString();
    SetCtxFont(ctx, fontInfo);

    var contentLength = rowContent.length;
    var txtDim;
    var textalign = this.TEGetAlignment(false);
    var contentLengthPixels = this.TEGetTextHOffset(rowContent, true, textalign, true);

    var subContent;
    var insertStart = 0;

    var priorLength = contentLengthPixels;
    while (contentLengthPixels < x) {
      insertStart++;
      if (insertStart >= contentLength) contentLengthPixels = x;
      else {
        subContent = rowContent.substring(0, insertStart);
        txtDim = ctx.measureText(subContent);
        priorLength = contentLengthPixels;
        contentLengthPixels =
          Math.ceil(txtDim.width) + this.TEGetTextHOffset(rowContent, true, textalign, true);
      }
    }

    var leftDelta = Math.abs(x - priorLength);
    var rightDelta = Math.abs(x - contentLengthPixels);

    if (leftDelta <= rightDelta) insertStart--;

    if (insertStart < 0) insertStart = 0;

    insertStart += rowBase;
    //console.log("Insert Start:", insertStart, " x:", x, " contentLengthPixels:",contentLengthPixels);
    return insertStart;
  }

  GetRowHeight() {
    var fontString = this.TEGetFontString();
    var rowH = MeasureTextHeight(fontString, this.GetFontSize());
    rowH += 2;

    return rowH;
  }

  OutofBounds(p) {
    var clipCoords = this.fClippedRegionCoords;
    var x = p.fX;
    var y = p.fY;
    if (x < clipCoords.sx || x > clipCoords.ex) return true;
    else if (y < clipCoords.sy || y > clipCoords.ey) return true;
    return false;
  }

  TEDrawCursor(drawBuffer) {
    // We have a range so there is no need to draw the cursor
    if (this.fInsertionStart != this.fInsertionEnd) return;

    var ctx = drawBuffer.getContext("2d");

    var p = this.ConvertInsertionToLocation();
    p.fX += ThicknessAdjuster(1);
    p.fY--;

    if (this.OutofBounds(p)) return;

    ctx.save();
    var sColor = this.GetFillColor();
    var sColorText = DetermineBrightness(sColor) < gBrightnessThreshold ? "#FFFFFF" : "#777777";
    ctx.strokeStyle = sColorText;
    ctx.lineWidth = 1;
    ctx.linecap = "square";

    ctx.beginPath();
    var rowHeight = this.GetRowHeight();

    p.fX -= 1; // One pixel to the left of the char

    var bottom = p.fY + rowHeight;

    var boxHeight = this.GetHeight();
    if (bottom > this.GetPositionY() + boxHeight) bottom = this.GetPositionY() + boxHeight;

    ctx.moveTo(p.fX, p.fY);
    ctx.lineTo(p.fX, bottom);

    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }

  SetInsertionStart(panelX, panelY) {
    this.fControlInsertionStart = this.ConvertLocationToInsertion(panelX, panelY);
  }

  DoStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    this.SetInsertionStart(panelX, panelY);
    this.FindInsertionPoints(panelX, panelY);
    return true;
  }

  StartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    return this.DoStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown);
  }

  // Override from QElement
  DoInteractWithElement(x, y) {
    // X and Y are in element coords
    // Find Insertion Point is in canvas coordinates
    x = x + this.GetPositionX();
    y = y + this.GetPositionY();
    this.FindInsertionPoints(x, y);
  }

  FindInsertionPoints(x, y) {
    var curInsertion = this.ConvertLocationToInsertion(x, y);
    var startInsertion = this.fControlInsertionStart;

    var si, ei;
    if (startInsertion < curInsertion) {
      si = startInsertion;
      ei = curInsertion;
    } else if (startInsertion > curInsertion) {
      si = curInsertion;
      ei = startInsertion;
    } else {
      si = curInsertion;
      ei = si;
    }

    this.fInsertionStart = si;
    this.fInsertionEnd = ei;
  }

  //=================================================================================================
  // Rendering
  TERenderExtras(drawBuffer) {}

  TEClipToParent(drawBuffer) {}

  RenderSelectionHighlight(drawBuffer, fillColor) {}

  DoRenderNoCache(
    drawBuffer,
    inEditMode // , copyToCache)
  ) {
    if (!inEditMode) {
      var fillMode = this.TEGetFillMode();
      if (this.fShown == false || (fillMode == enumFillMode.noFill && this.TERenderText() == false))
        return;
    }
    var ctx = drawBuffer.getContext("2d");

    this.ClipRenderElement(drawBuffer);
    ctx.save();
    this.TEClipToParent(drawBuffer);
    this.TERenderExtras(drawBuffer);

    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    var sw = this.GetWidth();
    var sh = this.GetHeight();

    if (sw == 0 || sh == 0) return;

    var inEditMode = this.InEditMode();
    this.DoRenderNoCache(drawBuffer, inEditMode);

    if (this.InEditMode()) {
      var curTimeMilli = Date.now();
      if (curTimeMilli - this.fLastCursorTime > 500) {
        this.fCursorVisible = !this.fCursorVisible;
        this.fLastCursorTime = curTimeMilli;
      }
      if (this.fCursorVisible) this.TEDrawCursor(drawBuffer);
    }
  }

  EditModeCursorFlash(drawBuffer) {}

  GetBlankMessage() {
    return this.fBlankMsg;
  }

  SetBlankMessage(blankMsg) {
    this.fBlankMsg = blankMsg;
  }

  //=================================================================================================
  // Autoresizing
  SetAutoResize(autoResize) {
    this.fEnableAutoResize = autoResize;
  }

  AutoResizeEnabled() {
    return this.fEnableAutoResize;
  }

  SetAutoResizeBehavior(behavior) {
    this.fAutoSizeBehavior = behavior;
  }

  AutoResize() {
    if (!this.AutoResizeEnabled()) return;

    var theContent = this.GetEditContent();

    // CellEdit is for editing within a cell like Excel
    // !CellEdit is for editing without a bounding cell
    var cellEdit = this.fAutoSizeBehavior == enumAutoSizeBehavior.cellEdit;

    var contentWidth =
      this.TEMeasureText(theContent) + this.TELeftIndent() + 2 * this.GetCellHPadding(); //this.TERightIndent()
    if (!cellEdit) contentWidth += 4;

    var origWidth;
    if (this.fStartWidth == null) origWidth = this.GetWidth();
    else origWidth = this.fStartWidth;

    var origStartX;
    if (this.fStartHorzPos == null) origStartX = this.GetPositionX();
    else origStartX = this.fStartHorzPos;

    var newPosX;
    var newWidth = contentWidth;

    if (cellEdit && contentWidth <= origWidth) newWidth = origWidth;

    var align = this.TEGetAlignment(false);
    switch (align) {
      case "left":
        newPosX = origStartX;
        break;
      case "center":
        newPosX = origStartX - Div2Floor(newWidth - origWidth); // Math.floor((newWidth-origWidth)/2);
        if (newPosX > origStartX) newPosX = origStartX;
        break;
      case "right":
        newPosX = origStartX + origWidth - newWidth;
        if (newPosX > origStartX) newPosX = origStartX;
        break;
    }

    var curWidth = this.GetWidth();
    if (curWidth != newWidth) this.SetWidth(newWidth);

    var curPosX = this.GetPositionX();
    if (curPosX != newPosX) this.SetPositionX(newPosX);
  }

  //=================================================================================================
  // Get/Set of contents and Password handling
  DoMaskContent(content) {
    var mask = "";
    var n = content.length;
    for (var i = 0; i < n; i++) mask += kBulletChar; //"\xA9"; //mask += "*";

    return mask;
  }

  SetMaskContent(doMaskContent) {
    this.fMaskContent = doMaskContent;
  }

  IsContentMasked() {
    return this.fMaskContent;
  }

  // Display Content uses fielddefobj to get formatted field value on geteditcontent() function call
  SetDisplayContent(fieldDef) {
    this.fDisplayContent = true;
    this.fFieldDef = fieldDef;
  }

  GetDisplayContent(content) {
    if (this.InEditMode() || content.length == 0) return String(content);
    return FormatFieldValue(content, this.fFieldDef);
  }

  IsDisplayContent() {
    return this.fDisplayContent;
  }

  ReplaceEditContent(str) {
    this.SetEditContent(str);
    this.SetInsertAtEnd();
  }

  ContentChanged() {
    //override
  }

  SetEditContent(theContent) {
    if (theContent != null) theContent = String(theContent);

    if (this.fContent != theContent) {
      this.fContent = theContent;
      this.ContentChanged();
      this.UpdateClearButton();
    }
  }

  SetIntEditContent(theContent) {
    if (isNumeric(theContent)) {
      this.fContent = theContent;
    }
  }

  UpdateClearButton() {}

  GetAnyContent() {
    if (!this.GetRealContent()) return String(this.fPriorContent);
    else return this.GetRealContent();
  }

  GetRealContent() {
    return String(this.fContent);
  }

  GetEditContent() {
    if (this.IsContentMasked()) return this.DoMaskContent(this.fContent);

    if (this.IsDisplayContent()) return this.GetDisplayContent(this.fContent);

    return String(this.fContent);
  }

  //=================================================================================================
  // Clipboard
  DoCut() {
    if (this.IsContentMasked()) return null;

    var cbBuffer = this.DoCopy();
    this.InsertString("");
    return cbBuffer;
  }

  DoCopy() {
    if (this.IsContentMasked()) return null;

    var theContent = this.GetAnyContent();
    if (this.fInsertionStart > -1 && this.fInsertionEnd > -1)
      theContent = theContent.slice(this.fInsertionStart, this.fInsertionEnd);

    //	var cbBuffer = new QClipboardBuffer();
    //	cbBuffer.Init(theData, kCBTextContent);

    var cbBuffer = theContent;
    if (!event || !event.clipboardData) copyTextToClipboardNoEvent(theContent);
    else copyTextToClipboard(theContent);
    return cbBuffer;
  }

  DoPaste(theBuffer) {
    var theData = theBuffer.replace(/(\r|\t)/gm, " "); // .GetContent();
    theData = theData.trim();
    this.InsertString(theData);
  }

  GetEnableEsc() {
    return this.fEnableEsc;
  }

  SetEnableEsc(enableEsc) {
    this.fEnableEsc = enableEsc;
  }

  GetReturnNewline() {
    return this.fReturnNewline;
  }

  HandleReturnKey() {
    //Override to produce behavior on enter key
    return false;
  }
}
